import { render, staticRenderFns } from "./TeslaVehicleList.vue?vue&type=template&id=566ad013"
import script from "./TeslaVehicleList.vue?vue&type=script&lang=js"
export * from "./TeslaVehicleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports